import { getData } from "@/utils/http";
import Big from "big-js";
export default {
    namespaced: true,
    state: {
        activeTab: "1",
        waybillId: "",
        //运单
        waybillItem: null
    },
    mutations: {
        CHANGE_TAB(state, item) {
            state.activeTab = item;
        },
        CHANGE_WAYBILLID(state, item) {
            state.waybillId = item;
        },
        CHANGE_WAYBILL_ITEM(state, item) {
            state.waybillItem = item;
        },
    },
    actions: {
        setWaybillId({ commit }, id) {
            commit("CHANGE_WAYBILLID", id);
        },
        setWaybillItem({ commit }, item) {
            commit("CHANGE_WAYBILL_ITEM", item);
        },
        setTabData({ commit }, changeData) {
            commit("CHANGE_TAB", changeData);
        },
    },
};
